import React from 'react';

// ─────────────────────────────────────────────────────────────────────────────
// Iconografía de la consola. Trazo fino de 1,5 px sobre caja de 24, como en el
// prototipo: ningún ícono relleno, ningún emoji. Se exporta un único `Ic` con
// el nombre del glifo para no repetir quince veces el mismo `<svg>` con sus
// atributos.
// ─────────────────────────────────────────────────────────────────────────────

const PATHS: Record<string, React.ReactNode> = {
  campana: (
    <>
      <path d="M18 8a6 6 0 1 0-12 0c0 6-2 7-2 7h16s-2-1-2-7" />
      <path d="M10.5 20a1.8 1.8 0 0 0 3 0" />
    </>
  ),
  lupa: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.5-3.5" />
    </>
  ),
  mas: <path d="M12 5v14M5 12h14" />,
  chevron: <path d="m6 9 6 6 6-6" />,
  atras: <path d="M15 5l-7 7 7 7" />,
  adelante: <path d="M9 5l7 7-7 7" />,
  lapiz: (
    <>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5.5M12 7.6v.1" />
    </>
  ),
  candado: (
    <>
      <rect x="3.5" y="11" width="17" height="9.5" rx="2" />
      <path d="M7.5 11V7.2a4.5 4.5 0 0 1 9 0" />
    </>
  ),
  llave: (
    <path d="M12 2.6v4M12 17.4v4M21.4 12h-4M6.6 12h-4M18.4 5.6l-2.8 2.8M8.4 15.6l-2.8 2.8M18.4 18.4l-2.8-2.8M8.4 8.4 5.6 5.6" />
  ),
  bloquear: (
    <>
      <circle cx="12" cy="12" r="8.6" />
      <path d="m5.9 5.9 12.2 12.2" />
    </>
  ),
  tacho: <path d="M3.5 6h17M9 6V4h6v2M18.5 6l-1 14h-11l-1-14" />,
  recalcular: (
    <>
      <path d="M20.5 12a8.5 8.5 0 1 1-2.5-6" />
      <path d="M20.5 3v6h-6" />
    </>
  ),
  barras: (
    <>
      <path d="M4 20V10.5" />
      <path d="M10 20V4" />
      <path d="M16 20v-7.5" />
      <path d="M22 20v-4" />
    </>
  ),
  palanca: (
    <>
      <circle cx="12" cy="12" r="8.6" />
      <path d="M12 7v6" />
    </>
  ),
  pausa: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="3" />
      <path d="M10 9v6M14 9v6" />
    </>
  ),
  engranaje: (
    <>
      <circle cx="12" cy="12" r="3.1" />
      <path d="M12 2.6v3M12 18.4v3M21.4 12h-3M5.6 12h-3M18.6 5.4l-2.1 2.1M7.5 16.5l-2.1 2.1M18.6 18.6l-2.1-2.1M7.5 7.5 5.4 5.4" />
    </>
  ),
  salir: (
    <>
      <path d="M15 17.5 19.5 12 15 6.5" />
      <path d="M19 12H9" />
      <path d="M12 4.5H5.5v15H12" />
    </>
  ),
  luna: <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" />,
  sol: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2.6v2.2M12 19.2v2.2M21.4 12h-2.2M4.8 12H2.6M18.6 5.4l-1.6 1.6M7 17l-1.6 1.6M18.6 18.6 17 17M7 7 5.4 5.4" />
    </>
  ),
  refrescar: (
    <>
      <path d="M20.5 12a8.5 8.5 0 1 1-2.5-6" />
      <path d="M20.5 3v6h-6" />
    </>
  ),
  cruz: <path d="M6 6l12 12M18 6 6 18" />,
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  pulgarArriba: (
    <>
      <path d="M7 21V10.5l4.5-7a2 2 0 0 1 3.4 1.9L13.5 9h5a2 2 0 0 1 2 2.3l-1.2 7A2.4 2.4 0 0 1 17 20.4H7Z" />
      <path d="M7 10.5H4.5v10.5H7" />
    </>
  ),
  pulgarAbajo: (
    <>
      <path d="M17 3v10.5l-4.5 7a2 2 0 0 1-3.4-1.9L10.5 15h-5a2 2 0 0 1-2-2.3l1.2-7A2.4 2.4 0 0 1 7 3.6h10Z" />
      <path d="M17 13.5h2.5V3H17" />
    </>
  ),
  cadena: (
    <>
      <path d="M10 13.5a4 4 0 0 0 5.7 0l2.6-2.6a4 4 0 0 0-5.7-5.7l-1.3 1.3" />
      <path d="M14 10.5a4 4 0 0 0-5.7 0l-2.6 2.6a4 4 0 1 0 5.7 5.7l1.3-1.3" />
    </>
  ),
  billete: (
    <>
      <rect x="2.6" y="6" width="18.8" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
    </>
  ),
  reloj: (
    <>
      <circle cx="12" cy="12" r="8.6" />
      <path d="M12 7v5.3l3.3 2" />
    </>
  ),
  persona: (
    <>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M4.8 20.2a7.2 7.2 0 0 1 14.4 0" />
    </>
  ),
};

export function Ic({
  n,
  size = 16,
  style,
}: {
  n: keyof typeof PATHS | string;
  size?: number;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      aria-hidden
    >
      {PATHS[n] ?? null}
    </svg>
  );
}

// ── Marca ────────────────────────────────────────────────────────────────────
// Logotipo oficial en hairline; el «BO» es un recorte del MISMO trazado (mismo
// alto de viewBox ⇒ misma escala tipográfica, sin fuente de sustitución).
export function Wordmark({ height = 15 }: { height?: number }) {
  return (
    <svg
      className="wm"
      height={height}
      viewBox="0 0 2338.14 277.86"
      fill="currentColor"
      role="img"
      aria-label="Yieldbox"
    >
      <polygon points="2338.14 15.67 2321 0 2209.7 121.71 2098.41 0 2081.27 15.67 2193.96 138.93 2081.27 262.17 2098.41 277.86 2209.7 156.15 2321 277.86 2338.14 262.17 2225.45 138.93 2338.14 15.67" />
      <path d="M375.43,270.02V7.84h26.97v262.18h-26.97Z" />
      <path d="M527.88,270.02V7.84h182.4v25.1h-155.06v93.63h140.08v24.34h-140.08v93.64h155.06v25.47h-182.4Z" />
      <path d="M827.14,270.02V7.84h27.34v236.71h135.21v25.47h-162.55Z" />
      <path d="M1100.17,270.39V7.46h84.64c37.7,0,69.41,12.55,95.14,37.64,25.71,25.1,38.7,56.37,38.95,93.82,0,37.21-12.8,68.42-38.39,93.64-25.6,25.22-57.49,37.83-95.7,37.83h-84.64ZM1127.52,244.55h57.3c31.21,0,56.87-10.05,76.97-30.15,20.09-20.1,30.15-45.25,30.15-75.47s-10.12-56.05-30.34-76.03c-20.23-19.97-45.83-29.96-76.78-29.96h-57.3v211.61Z" />
      <path d="M1431.64,270.02V7.84h112.36c23.97,0,42.82,5.99,56.55,17.98,13.73,11.99,20.6,28.09,20.6,48.32,0,14.74-3.62,27.47-10.86,38.21-7.25,10.74-17.36,18.35-30.34,22.84,33.45,9.24,50.19,30.59,50.19,64.05,0,22.23-7.3,39.58-21.91,52.06-14.61,12.49-34.78,18.73-60.49,18.73h-116.11ZM1457.86,125.44h83.15c16.48,0,29.65-4.31,39.52-12.92,9.86-8.61,14.79-20.29,14.79-35.02s-4.62-25.03-13.86-33.15c-9.24-8.11-21.85-12.18-37.83-12.18h-85.77v93.26ZM1457.86,245.3h88.39c17.73,0,31.58-4.31,41.57-12.92,9.98-8.61,14.98-20.91,14.98-36.89s-5.43-28.53-16.29-36.15c-10.86-7.61-25.04-11.42-42.51-11.42h-86.15v97.38Z" />
      <path d="M1863.49,273.01c-36.96,0-68.11-13.04-93.45-39.14-25.35-26.09-38.02-57.74-38.02-94.95s12.73-68.54,38.2-94.75c25.47-26.22,56.56-39.33,93.26-39.33s67.48,13.05,93.08,39.14c25.59,26.09,38.51,57.75,38.76,94.95,0,36.96-12.8,68.54-38.39,94.76-25.6,26.22-56.74,39.33-93.45,39.33ZM1788.96,215.52c19.97,21.11,44.82,31.65,74.53,31.65s54.56-10.48,74.53-31.46c19.97-20.97,29.96-46.57,29.96-76.78s-9.99-55.86-29.96-76.97c-19.98-21.1-44.82-31.65-74.53-31.65s-54.25,10.55-74.35,31.65c-20.1,21.1-30.15,46.76-30.15,76.97s9.98,55.5,29.96,76.59Z" />
      <polygon points="290.16 26.58 275.54 8.52 145.08 114.13 14.62 8.52 0 26.58 133.46 134.62 133.46 273.06 156.7 273.06 156.7 134.62 290.16 26.58" />
    </svg>
  );
}

export function BoMark({ height = 15 }: { height?: number }) {
  return (
    <svg
      className="bo"
      height={height}
      viewBox="1431.63 0 563.69 277.86"
      fill="currentColor"
      role="img"
      aria-label="Backoffice"
    >
      <path d="M1431.64,270.02V7.84h112.36c23.97,0,42.82,5.99,56.55,17.98,13.73,11.99,20.6,28.09,20.6,48.32,0,14.74-3.62,27.47-10.86,38.21-7.25,10.74-17.36,18.35-30.34,22.84,33.45,9.24,50.19,30.59,50.19,64.05,0,22.23-7.3,39.58-21.91,52.06-14.61,12.49-34.78,18.73-60.49,18.73h-116.11ZM1457.86,125.44h83.15c16.48,0,29.65-4.31,39.52-12.92,9.86-8.61,14.79-20.29,14.79-35.02s-4.62-25.03-13.86-33.15c-9.24-8.11-21.85-12.18-37.83-12.18h-85.77v93.26ZM1457.86,245.3h88.39c17.73,0,31.58-4.31,41.57-12.92,9.98-8.61,14.98-20.91,14.98-36.89s-5.43-28.53-16.29-36.15c-10.86-7.61-25.04-11.42-42.51-11.42h-86.15v97.38Z" />
      <path d="M1863.49,273.01c-36.96,0-68.11-13.04-93.45-39.14-25.35-26.09-38.02-57.74-38.02-94.95s12.73-68.54,38.2-94.75c25.47-26.22,56.56-39.33,93.26-39.33s67.48,13.05,93.08,39.14c25.59,26.09,38.51,57.75,38.76,94.95,0,36.96-12.8,68.54-38.39,94.76-25.6,26.22-56.74,39.33-93.45,39.33ZM1788.96,215.52c19.97,21.11,44.82,31.65,74.53,31.65s54.56-10.48,74.53-31.46c19.97-20.97,29.96-46.57,29.96-76.78s-9.99-55.86-29.96-76.97c-19.98-21.1-44.82-31.65-74.53-31.65s-54.25,10.55-74.35,31.65c-20.1,21.1-30.15,46.76-30.15,76.97s9.98,55.5,29.96,76.59Z" />
    </svg>
  );
}

// ── Activos ──────────────────────────────────────────────────────────────────
// Paleta y glifos: MISMA fuente que la web (lib/asset-colors) y que el
// TickerAvatar del BO. Se replica acá para que la consola no dependa del átomo
// viejo (que está atado a los tokens del tema claro de MUI).
export const AC: Record<string, string> = {
  USD: '#a7afc2', EUR: '#6f86a8', CHF: '#8e9bb0', BTC: '#c59a66',
  XAU: '#cabb84', SPY: '#8fa896', QQQ: '#7f9a86', ETH: '#9994c9',
  BNB: '#b09a55', SOL: '#b386ab', USDT: '#a7afc2', USDC: '#7f9cbd',
  PAXG: '#cabb84', DAI: '#b894b0',
};

const FALLBACK = ['#b9b3a4', '#9ba7b0', '#a8a0b4', '#b0a892', '#97a6a0', '#aeb0a6'];

export function assetColor(ticker?: string, i = 0): string {
  const key = String(ticker || '').toUpperCase();
  return AC[key] ?? FALLBACK[((i % FALLBACK.length) + FALLBACK.length) % FALLBACK.length];
}

const GLYPH: Record<string, React.ReactNode> = {
  USD: (
    <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="52" fontWeight="300" fill="currentColor">$</text>
  ),
  EUR: (
    <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="50" fontWeight="300" fill="currentColor">€</text>
  ),
  XAU: (
    <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="40" fontWeight="300" fill="currentColor">Au</text>
  ),
  PAXG: (
    <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="34" fontWeight="400" fill="currentColor">PAX</text>
  ),
  BTC: (
    <g fill="none" stroke="currentColor" strokeWidth={4.8} strokeLinejoin="round">
      <path d="M34 20 L34 80" />
      <path d="M34 20 L54 20 C67 20 67 50 54 50 L34 50" />
      <path d="M34 50 L57 50 C71 50 71 80 55 80 L34 80" />
      <path d="M44 15 L44 85" />
      <path d="M56 15 L56 85" />
    </g>
  ),
  ETH: (
    <g fill="none" stroke="currentColor" strokeWidth={4.8}>
      <path d="M26 17 L74 17" />
      <path d="M26 50 L74 50" />
      <path d="M26 83 L74 83" />
    </g>
  ),
  SOL: (
    <g stroke="currentColor" fill="none" strokeWidth={4.8}>
      <circle cx="50" cy="50" r="33" />
      <circle cx="50" cy="50" r="9.5" fill="currentColor" stroke="none" />
    </g>
  ),
  BNB: (
    <g fill="none" stroke="currentColor" strokeWidth={4.8} strokeLinejoin="round">
      <path d="M50 36 L64 50 L50 64 L36 50 Z" />
      <path d="M50 16 L59 25 L50 34 L41 25 Z" />
      <path d="M50 66 L59 75 L50 84 L41 75 Z" />
      <path d="M24 41 L33 50 L24 59 L15 50 Z" />
      <path d="M76 41 L85 50 L76 59 L67 50 Z" />
    </g>
  ),
  CHF: (
    <g fill="none" stroke="currentColor" strokeWidth={6.2}>
      <path d="M50 27 L50 73" />
      <path d="M27 50 L73 50" />
    </g>
  ),
  SPY: (
    <g fill="none" stroke="currentColor" strokeWidth={4.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 68 L42 45 L57 57 L80 32" />
    </g>
  ),
  QQQ: (
    <g fill="none" stroke="currentColor" strokeWidth={4.8} strokeLinecap="round">
      <circle cx="50" cy="46" r="27" />
      <path d="M67 63 L81 77" />
    </g>
  ),
};

/** Ficha redonda del activo: glifo en su color, velo tenue y borde del mismo tono. */
export function Tk({ t, size = 26 }: { t?: string; size?: number }) {
  const key = String(t || '').toUpperCase();
  const c = assetColor(key);
  const g = GLYPH[key] ?? (
    <text x="50" y="50" textAnchor="middle" dominantBaseline="central" fontSize="30" fontWeight="500" fill="currentColor">
      {key.slice(0, 3)}
    </text>
  );
  return (
    <span
      className="tk"
      style={{
        width: size,
        height: size,
        color: c,
        background: `${c}29`,
        border: `1px solid ${c}4d`,
      }}
    >
      <svg width={Math.round(size * 0.66)} height={Math.round(size * 0.66)} viewBox="0 0 100 100">
        {g}
      </svg>
    </span>
  );
}

/** Ficha + ticker, la unidad que se repite en toda fila que nombra un activo. */
export function TkRow({
  t,
  size = 26,
  extra,
}: {
  t?: string;
  size?: number;
  extra?: React.ReactNode;
}) {
  return (
    <span className="tkrow">
      <Tk t={t} size={size} />
      <span>
        {String(t || '—').toUpperCase()}
        {extra}
      </span>
    </span>
  );
}

// Paleta de series de los gráficos (misma secuencia que el prototipo).
export const PAL = [
  '#8a96ab', '#c59a66', '#9994c9', '#cabb84', '#b386ab',
  '#8fa896', '#b09a55', '#8e9bb0', '#7f9a86', '#a7afc2',
];
export const cc = (i: number): string => PAL[i % PAL.length];
